import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { BRANDS_STATE } from '../../constants';

import { FavouriteBrand } from '../../types';

export const addFavouriteBrands = createReduxAsyncThunk<
  { favouriteBrands: Pick<FavouriteBrand, 'billingId' | 'logo' | 'title'>[] },
  FavouriteBrand['billingId'][]
>(
  `${BRANDS_STATE}/addFavouriteBrands`,
  async (billingIds) => {
    return await dataSources.brands.addFavouriteBrands(billingIds);
  }
);
